/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 * Created Date: Sunday, 17th February 2019
 *
 *  Portal - Email Verification View
 */
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { useStores } from 'stores/RootStore';

// Material UI
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import ContactMailIcon from '@material-ui/icons/ContactMail';

const EmailVerification = props => {
  const { classes } = props;
  const stores = useStores();
  const { currentUser } = stores.authStore;
  const [isLoading, setLoading] = useState(false);

  const handleEmailVerification = () => {
    setLoading(true);

    // Send Verification Email for currently logged in user.
    currentUser
      .sendEmailVerification()
      .then(() => {
        // Verification Email Sent
        stores.portalStore.snackbar.showSnackbarWithDismiss(
          'Verification Email sent, please check your inbox.',
          'success',
          6000
        );
        setLoading(false);
      })
      .catch(error => {
        // Error
        setLoading(false);
        stores.appStore.error('system', error);
      });
  };

  stores.appStore.setView('Verify');

  return (
    <Grid container justify='center' alignContent='center' direction='column' className={classes.welcome}>
      <Grid item xs={12}>
        <Card className={classes.card}>
          <CardHeader
            avatar={<ContactMailIcon className={classes.cardIcon} />}
            title={'Welcome to VendorBadge'}
            titleTypographyProps={{
              className: classes.cardHeaderTitle,
            }}
            subheader={'Please verify your email address'}
            className={classes.cardHeader}
          />
          <CardContent className={classes.cardContent}>
            <Typography variant='body1' className={classes.cardContentBody}>
              If you are having trouble locating the email that was sent during registration, or that link has expired,
              click on the button below to have a new email sent.
            </Typography>
          </CardContent>
          <CardActions className={classes.cardActions}>
            <div className={classes.buttonWrapper}>
              <Button
                variant='contained'
                disabled={isLoading}
                type='submit'
                color='primary'
                className={classes.formButton}
                style={{ width: '275px' }}
                onClick={handleEmailVerification}
              >
                Send Verification Email
              </Button>
              {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </div>
          </CardActions>
        </Card>
      </Grid>
    </Grid>
  );
};

EmailVerification.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = theme => ({
  root: {},
  card: {
    maxWidth: '550px',
  },
  cardHeader: {},
  cardHeaderTitle: {
    fontSize: '14pt',
  },
  cardIcon: {
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
    fontSize: '36pt',
    color: theme.palette.type === 'dark' ? theme.palette.common.white : theme.palette.secondary.main,
  },
  cardContent: {
    paddingTop: '5px',
    paddingRight: '25px',
    paddingLeft: '25px',
  },
  cardContentBody: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '10pt',
    },
  },
  cardActions: {
    justifyContent: 'center',
    textAlign: 'center',
  },
  welcome: {
    marginTop: '35px',
  },
  buttonWrapper: {
    position: 'relative',
  },
  formButton: {
    marginBottom: '15px',
    fontSize: '10pt',
  },
  buttonProgress: {
    zIndex: 1,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -20,
    marginLeft: -15,
  },
});

export default withStyles(styles, { withTheme: true })(observer(EmailVerification));
